/**
 * 市场活动
 */
import React from 'react';
import {  Row, Col, Icon, Tooltip, Button,DatePicker} from 'antd';
import PageLayout from '../../ui/PageLayout';
import MarketActivityEdit from './MarketActivityEdit';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth'

class MarketActivityIndex extends React.Component {

    columns = [{
        title: '活动类型',
        dataIndex: 'type',
        width: '10%',
    }, {
        title: '活动名称',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '活动投放',
        dataIndex: 'launch',
        width: '10%',
    }, {
        title: '活动费用',
        dataIndex: 'fees',
        width: '10%',
    }, {
        title: '开始时间',
        dataIndex: 'startDate',
        width: '10%',
    }, {
        title: '结束时间',
        dataIndex: 'endDate',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("REPORT_MARKET_ACTIVITY_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("REPORT_MARKET_ACTIVITY_UPDATE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {}
    };

    showModal = () => {
        this.setState({ visible: true });
    };
    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    add = () => {
        this.setState({ editData: {} });
        this.showModal();
    }

    update = (info, e) => {
        this.setState({ editData: info });
        this.showModal();
    }

    delete = (info, e) => {
        http.post({
            url: "/marketActivity/delectActivity",
            data: { id: info },
            success: (res) => {
                this.state.loadData(this.state.queryData);
                messager.notify("删除成功！");
            }
        });
    }
   

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange}/>
                                <OrgSelect style={{ width: '200px', marginLeft: "10px" }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("REPORT_MARKET_ACTIVITY_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/marketActivity/findActivityPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MarketActivityEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

export default MarketActivityIndex;